import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, Input, Text } from '@match/react-component-library';

const { SEMANTIC_COLOR_NAME, SPACE } = constants;

interface EmailAddressProps {
  emailAddress: string | undefined;
  emailError: boolean;
  onEmailAdd: (event: React.ChangeEvent<HTMLInputElement> | undefined) => void;
}

export const EmailAddress: React.FunctionComponent<EmailAddressProps> = ({
  emailAddress,
  emailError,
  onEmailAdd,
}) => {
  const intl = useIntl();

  return (
    <Box marginBottom={SPACE.XLARGE}>
      <Box marginBottom={SPACE.SMALL}>
        <FormattedMessage {...messages.email} />
      </Box>
      <Input
        onChange={onEmailAdd}
        placeholder={intl.formatMessage(messages.email)}
        value={emailAddress}
        width="100%"
      />
      <div>
        {emailError && (
          <Text color={SEMANTIC_COLOR_NAME.ERROR}>
            <FormattedMessage {...messages.emailErrorText} />
          </Text>
        )}
      </div>
    </Box>
  );
};

const messages = defineMessages({
  email: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/EmailAddress/EmailAddress:email',
    description: 'email address input placeholder',
    defaultMessage: 'Email Address',
  },
  emailErrorText: {
    id: 'src/modules/pages/ContactUsPage/ContactUsSC3/EmailAddress/EmailAddress:emailErrorText',
    description: 'email address error text',
    defaultMessage: 'Email Address must be properly formatted',
  },
});
